<script>
import { onMounted, ref, reactive, defineComponent, computed, watch } from 'vue'
import ResumeTemplateDraw from '@/components/ResumeTemplateDraw'
import { useWindowSize } from '@vueuse/core'
import PickColor from 'vue-pick-colors'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { commonTemplateArr, defaultData } from '@/templates/resumeTemplate'
import { Loading } from '@/templates/loading'
import ResumeLogo from '@/assets/images/resume.svg'
import FinalInfo from "../../components/FinalInfo"
import { EyeOutlined } from '@ant-design/icons-vue';
import NavAiToolMenu from '@/components/navAiToolMenu'
import Countdown from '@/components/Countdown'
import ResumeList from '@/components/ResumeList';
import { getUrlQuery } from '@/utils/getUrlQuery';
import { storage } from '../../utils/storage'
// 按需引入 ant-design-vue 组件
import {
  Button,
  Tooltip,
  Modal,
  Select,
  Input,
  Layout,
  message
} from 'ant-design-vue';
import config from "../../config"
import { getUserStoreTemplateArr } from "../../utils/common.js"
export default defineComponent({
  components: {
    FinalInfo,
    EyeOutlined,
    ResumeTemplateDraw,
    NavAiToolMenu,
    Countdown,
    ResumeList,
    PickColor,
    AButton: Button,
    ATooltip: Tooltip,
    AModal: Modal,
    ASelect: Select,
    AInput: Input,
    ALayoutHeader: Layout.Header,
  },
  setup () {
    // 变量
    const { width } = useWindowSize()
    let menus = reactive([])
    let filterMenu = ref([])
    let templates = ref([])
    const selectedKeys = ref(['2'])
    const activeKey = ref('markdown')
    const resumeLogo = ref(ResumeLogo)
    const routers = useRouter()
    const store = useStore()
    let route = useRoute()
    const colorVal = ref('#1930a1')
    let gangweiReplaceVisible = ref(false)
    let myResumeListVisible = ref(false);
    let visible = ref(false);
    let modelText = ref('岗位模版');
    const isEditePage = computed(() => {
      return route.name === 'Resume'
    })
    let countdownRuning = computed(() => store.state.isLogin && store.state.userInfos.username && isEditePage.value);
    let showWapMenu = ref(false);
    const textoptions = ref([
      { value: 'system-ui', label: 'systemUi字体' },
      { value: 'cursive', label: 'cursive字体' },
      { value: 'fangsong', label: 'fangsong字体' },
      { value: 'monospace', label: 'monospace字体' },
    ]);
    // methods
    onMounted(async () => {
      try {
        menus = routers.getRoutes()
        filterMenu.value = menus.filter(menu => menu.children.length === 0)
        filterMenu.value = menus.filter(menu => menu.children.length === 0)
        setTempDataFn();
        console.log(filterMenu, 'routers')
        window.$Bus.on('emitsetTempDataFn', (params) => {
            setTempDataFn(params);
        });
        window.$Bus.on('emitstoreTemplateDataFn', (params) => {
          // message.info('温馨提示: 修改后请及时保存,防止意外数据丢失~')
        });
      } catch (error) {}
    })

    const handleOk = () => {
      visible.value = false;
      goLoginFn();
    };

    const resumeTotalNum = computed(() => '1' + " + " + store.state.serverResumeV2List.length);

    const setTempDataFn = async (params) => {
      let template = []
      let showTemplateAddCurstyleTypeData = {};
      try {
        if (!store.state.userInfos || !store.state.userInfos.userid) {
          throw Error('userid is empty');
        }
        let {
          allStyleTempArr,
          useStyleTemp,
          templateData,
          templateAddCurstyleTypeData
        } = await getUserStoreTemplateArr(store);
        showTemplateAddCurstyleTypeData = templateAddCurstyleTypeData;
        template = allStyleTempArr;
        console.log('serveTempArr:', template, showTemplateAddCurstyleTypeData);
      } catch (error) {
        template = template.concat([...commonTemplateArr, Loading]);
        showTemplateAddCurstyleTypeData = Object.assign({}, defaultData, template[0]);
        window.userServerSaveTemplateData = store.state.templateAddCurstyleTypeData = showTemplateAddCurstyleTypeData;
        console.log('localTempArr:', template, showTemplateAddCurstyleTypeData);
      }
      store.commit('CHANGE_RESUME_TEMPLATE', showTemplateAddCurstyleTypeData);
      // 首次自动选择
      window.$Bus.emit('emitResetTargetTemlate');
      store.state.templateArr = template;
      templates.value = template
      // 把默认简历构造成特定的格式数据并给一个id
      let defaultResumeId = '12345678';
      let defaultResumeData = {
        resumeCreateTime: '系统默认时间',
        resumeId: defaultResumeId,
        id: defaultResumeId,
        uid: store.state.userInfos.userid,
        resumeDesc: '系统默认简历禁止删除',
        type: 'defaultType',
        resumeTitle: '你的第一份简历',
        resumeData: showTemplateAddCurstyleTypeData,
      }
      store.state.defaultServeResumeData = defaultResumeData;
      store.state.curEditServeResumeId = defaultResumeId;
      // 获取服务端存储的简历列表
      store.commit('GET_RESUME_LIST');
    }
    // 切换tab标签页 --Deprecated
    const handleChange = (tab) => {
      activeKey.value = tab
      store.commit('CHANGE_MODE', tab)
    }
    // 修改简历主题色
    const changeTheme = (color) => {
      store.commit('CHANGE_RESUME_THEME', color)
    }
    // 切换菜单 --Deprecated
    const menuClick = (path) => {
      routers.push({
        path: path.key
      })
    }

    const printPDF = () => {
      if (!store.state.isLogin || !store.state.userInfos.username) {
        visible.value = true;
        return message.warning('请登录后再试')
      }
      store.commit('CHANGE_FULL_INFO')
    }
    const goLoginFn = () => {
      let loginPageUrl = `http://luckycola.com.cn/public/dist/#/allLoginPage?u=${encodeURIComponent(location.href)}`
      // let loginPageUrl = `http://luckycola.com.cn/public/dist/?okAfterClose=1#/allLoginPage`
      // location.href = loginPageUrl
      window.open(loginPageUrl)
    }
    const gangweiReplaceHandleOk = () => {
      gangweiReplaceVisible.value = false;
      store.state.isGangWeiTemplate = false;
      store.state.isAiCreateTemplate = false;
      store.commit('STORE_TEMPLATE_DATA');
    }
    const storeTemplateData = () => {
      if (!store.state.isLogin || !store.state.userInfos.username) {
        visible.value = true;
        return message.warning('请登录后再试')
      }
      // 判断是个是岗位模板使用场景
      const queryParams = getUrlQuery();
      let isGangWeiSence = (queryParams.from == 'templateCenter' && queryParams.type == 'gangwei' && store.state.isGangWeiTemplate);
      let isAiCreateSence = (queryParams.from == 'aiCreatePage' && store.state.isAiCreateTemplate && queryParams.type == 'aiCreate');
      modelText.value = isGangWeiSence ? '岗位模版' : 'AI创作模版';
      if (isGangWeiSence || isAiCreateSence) {
        gangweiReplaceVisible.value = true;
        return;
       }
      store.commit('STORE_TEMPLATE_DATA')
    }
    const goUcenter = () => {
      // message.info('用户中心')
      window.open('https://luckycola.com.cn/public/dist/?openSence=0&sence=airesume#/userCenter')
      // location.href = 'https://luckycola.com.cn/public/dist/?openSence=0&sence=airesume#/userCenter';
    }
    let isIndexPage = computed(() => {
      return route.name === 'Index'
    })
    const goIndexPage = () => {
      routers.push({
        name: 'Index'
      })
    }

    watch(() => route.name, (routeVal) => {
      // console.log('watch routeVal:', routeVal);
      store.state.curNavItemKey = routeVal;
    }, {
      immediate: true
    })

    const goChangePage = (type) => {
      store.state.curNavItemKey = type;
      switch(type) {
        case 'templatePage':
          routers.push({
            name: 'templatePage'
          })
          break
        case 'aiCreate':
          routers.push({
            name: 'aiCreate'
          });
          break
        case 'LuckyColaWeb':
          window.open('http://luckycola.com.cn')
          break
        case 'home':
        routers.push({
            name: 'Index'
          });
          break
        case 'Resume':
          // 记录当前路由
          storage.set('beforeResumeRouteName', route.name);
          routers.push({
            name: 'Resume'
          });
          break;
        case 'gongluePage':
          window.open('https://bytebay.codetom.top/creation/column/20009');
          break;
        default:
          break
      }
      showWapMenu.value = false;
    }
    // 检测是否为Safari浏览器
    const isSafari = computed(() => {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    });

    const goBackHandle = () => {
      if (isSafari.value && route.name === 'Resume') {
        console.log('Safari浏览器下的返回处理逻辑');
        let beforeResumeRouteNameVal = storage.get('beforeResumeRouteName') || 'templatePage';
        // Safari浏览器下的处理逻辑
        routers.push({ name: beforeResumeRouteNameVal });
        return;
      }
      history.back();
    }

    const showBackBtn = computed(() => {
      const showBackBtnRoutes = ['Resume', 'beforePreView'];
      return showBackBtnRoutes.includes(route.name)
    })

    const gotoBuyVipFn = () => {
      window.open(config.buyvipUrl);
    }

    const isVip = computed(() => {
      return store.state.vipData && store.state.vipData.status == 1;
    });
    const handleTextChange = (value) => {
      store.commit('CHANGE_RESUMEFONTFAMILY', value);
    };

    const finishCallback = () => {
      storeTemplateData();
    }

    const showMyResumeList = () => {
      if (!store.state.isLogin || !store.state.userInfos.username) {
        visible.value = true;
        return message.warning('请登录后再试')
      }
      const queryParams = getUrlQuery();
      let isGangWeiSence = (queryParams.from == 'templateCenter' && queryParams.type == 'gangwei' && store.state.isGangWeiTemplate);
      let isAiCreateSence = (queryParams.from == 'aiCreatePage' && store.state.isAiCreateTemplate && queryParams.type == 'aiCreate');
      let tipsText = isGangWeiSence ? '岗位模版' : 'AI创作模版';
      if (isGangWeiSence || isAiCreateSence) {
        message.warning(`《${tipsText}》「预览」模式下无法切换简历,请保存后再试`)
        return;
      };
      myResumeListVisible.value = true;
    }

    const creatResumeFn = () => {
      store.commit('CREATE_RESUME_NEW');
    }

    const closeVisibleHandle = () => {
      myResumeListVisible.value = false;
    }

    return {
      isVip,
      textoptions,
      width,
      store,
      colorVal,
      gotoBuyVipFn,
      storeTemplateData,
      handleTextChange,
      goLoginFn,
      selectedKeys,
      resumeLogo,
      filterMenu,
      printPDF,
      isIndexPage,
      menuClick,
      handleChange,
      changeTheme,
      goUcenter,
      goIndexPage,
      gangweiReplaceVisible,
      myResumeListVisible,
      creatResumeFn,
      resumeTotalNum,
      closeVisibleHandle,
      gangweiReplaceHandleOk,
      activeKey,
      templates,
      visible,
      handleOk,
      goChangePage,
      showWapMenu,
      showBackBtn,
      isEditePage,
      modelText,
      goBackHandle,
      finishCallback,
      showMyResumeList,
      countdownRuning
    }
  }
})
</script>

<template>
  <div class="top-menu-box">
    <a-layout-header style="height: 50px; background: #fff;">
      <div style="display: flex;align-items: center" v-if="width > 780">
        <div class="menu-style">
          <div :class="['header', showBackBtn ? 'header-backBtn' : '']" @click="goIndexPage">
            <span class="fab fa-slack mr-2 resumelogo"></span>
            <span class="web-title">ColaAICv</span>
          </div>
          <div class="menu-lists" v-if="!showBackBtn">
            <a-button
            v-if="!isIndexPage"
            @click="goChangePage('templatePage')"
            type="text"
            :class="[store.state.curNavItemKey === 'templatePage' ? 'mune-item-btn-active' : '']">
              <span class="ml-1 mune-item">模板广场</span>
            </a-button>
            <a-button
            v-if="!isIndexPage"
            @click="goChangePage('aiCreate')"
            type="text"
            :class="[store.state.curNavItemKey === 'aiCreate' ? 'mune-item-btn-active' : '']">
              <span class="ml-1 mune-item">AI生成简历</span>
            </a-button>
            <a-button
            v-if="!isIndexPage"
            @click="goChangePage('Resume')"
            type="text">
              <span class="ml-1 mune-item">简历制作</span>
            </a-button>
            <NavAiToolMenu></NavAiToolMenu>
            <a-button
            v-if="!isIndexPage && store.state.showGongluePage"
            @click="goChangePage('gongluePage')"
            class="ml-2"
            type="text">
              <span class="ml-1 mune-item">求职攻略</span>
            </a-button>
          </div>
          <div class="backbtn-box" v-else>
            <a-button
            @click="goBackHandle()"
            type="text"
            >
             <span class="fas fa-arrow-left mune-item-back"></span>
              <span class="ml-1 mune-item mune-item-back">返回</span>
            </a-button>
            <NavAiToolMenu></NavAiToolMenu>
            <span
            @click="showMyResumeList()"
            v-if="isEditePage"
            type="text"
            class="my-resume-list">
              <span class="ml-1 mune-item">我的简历</span>
            </span>
            <Countdown :finishCallback="finishCallback" :time="10" class="CountdownCls" afterText="后自动保存" :runing="countdownRuning"></Countdown>
          </div>
        </div>
      </div>
      <div class="wap-munue-box" v-else>
        <span class="more-icon fas fa-align-justify" @click="showWapMenu = !showWapMenu"></span>
        <section class="wap-munue-mask" v-if="showWapMenu">
          <span class="wap-munue-mask-close" @click="showWapMenu = false">X</span>
          <div class="wap-munue-body">
            <div class="wap-munue-item" @click="goChangePage('home')">首页<span class="fas fa-angle-right"></span></div>
            <div class="wap-munue-item" @click="goChangePage('templatePage')">模板广场<span class="fas fa-angle-right"></span></div>
            <div class="wap-munue-item" @click="goChangePage('aiCreate')">AI生成简历<span class="fas fa-angle-right"></span></div>
            <div class="wap-munue-item" @click="goChangePage('Resume')">简历制作<span class="fas fa-angle-right"></span></div>
            <div class="wap-munue-item" @click="goChangePage('LuckyColaWeb')">AI工具库<span class="fas fa-angle-right"></span></div>
            <div class="wap-munue-item" @click="goChangePage('gongluePage')" v-if="store.state.showGongluePage">求职攻略<span class="fas fa-angle-right"></span></div>
          </div>
        </section>
      </div>
      <div class="display-flex">
          <div class="operate-left">
          <div style="display:flex">
              <a-button @click="storeTemplateData" shape="round" ghost class="ml-2" v-if="isEditePage && width > 1000" type="primary">
                保存
              </a-button>
            <a-button @click="printPDF" shape="round" type="primary" danger class="ml-2" ghost v-if="isEditePage && width > 1000">
              导出
            </a-button>
            <a-button @click="goLoginFn" v-if="!store.state.isLogin || !store.state.userInfos.userid" type="primary" class="ml-4" shape="round">
              立即登录
            </a-button>
            <a-button @click="goUcenter" class="loginUser" ghost type="primary" v-else shape="round">
                <span class="fas fa-user-tie text-sm mr-2"></span>
                <span class="userNameSpan"> Dear, {{ store.state.userInfos.username }}</span>
                <a-tooltip placement="top" v-if="isVip">
                  <template #title>
                    <span>会员账号</span>
                  </template>
                  <svg t="1709443950264" class="vipSvgIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4299" width="200" height="200"><path d="M510.955102 831.738776c-23.510204 0-45.453061-9.926531-61.64898-27.167347L138.971429 468.114286c-28.734694-31.346939-29.779592-79.412245-1.567347-111.804082l117.55102-135.314286c15.673469-18.285714 38.661224-28.734694 63.216327-28.734694H705.306122c24.032653 0 47.020408 10.44898 62.693878 28.734694l118.073469 135.314286c28.212245 32.391837 27.689796 80.457143-1.567347 111.804082L572.081633 804.571429c-15.673469 17.240816-38.138776 27.167347-61.126531 27.167347z" fill="#F2CB51" p-id="4300"></path><path d="M506.77551 642.612245c-5.22449 0-10.971429-2.089796-15.15102-6.269388l-203.755102-208.979592c-7.836735-8.359184-7.836735-21.420408 0.522449-29.779592 8.359184-7.836735 21.420408-7.836735 29.779592 0.522449l189.12653 193.828572 199.053061-194.351021c8.359184-7.836735 21.420408-7.836735 29.779592 0.522449 7.836735 8.359184 7.836735 21.420408-0.522449 29.779592l-214.204081 208.979592c-4.179592 3.657143-9.404082 5.746939-14.628572 5.746939z" fill="#FFF7E1" p-id="4301"></path></svg>
                </a-tooltip>
            </a-button>
          </div>
        </div>
      </div>
    </a-layout-header>
    <FinalInfo />
    <ResumeTemplateDraw :templates="templates" />
    <a-modal v-model:open="visible" title="提示" @ok="handleOk" cancelText="取消" okText="去登录">
      <p>请登录后再试</p>
    </a-modal>
    <!-- 会员开通弹窗 -->
    <a-modal
      title="温馨提示"
      style="top: 20px"
      centered
      okText="去开通"
      cancelText="取消"
      v-model:open="store.state.modalVipVisible"
      @ok="gotoBuyVipFn"
    >
      <p class="text-lg text-center font-bold">您的"{{ store.state.modalVipVisibleMsg }}"次数已经用完,请开通会员继续使用</p>
      <p class="text-sm mt-2 text-gray-400 text-center"><b>注意:</b> 开通后如果会员未生效,请刷新页面再试</p>
    </a-modal>
    <!-- 岗位模板覆盖提示弹窗 -->
    <a-modal
    v-model:open="gangweiReplaceVisible"
    title="重要提示"
    okText="确定覆盖保存"
    cancelText="取消"
    @ok="gangweiReplaceHandleOk">
      <p>您正在使用{{ modelText}},保存将覆盖您的原有简历内容,是否继续?</p>
    </a-modal>
    <!-- 我的简历列表弹窗 -->
    <a-modal
    v-model:open="myResumeListVisible"
    :footer="null"
    :bodyStyle="{
      padding: '0px',
    }"
    title="我的简历">
      <div class="create-box">
        <span class="resume-total">当前共 {{resumeTotalNum}} 份</span>
        <span class="create-btn" @click="creatResumeFn">
          创建简历
          <b class="fas fa-plus"></b>
         </span>
      </div>
      <div class="myResumeListBox">
        <ResumeList :closeVisibleHandle="closeVisibleHandle"></ResumeList>
      </div>
    </a-modal>
  </div>
</template>

<style scoped lang="less">
.top-menu-box {
  .ant-layout-header {
    background: #fff !important;
    background-color: #fff !important;
  }
}

.menu-style {
  display: flex;
  .header {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 50px;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
    .resumelogo {
      color: #0094b5;
      background: linear-gradient(to right, rgb(18, 117, 255), rgb(157, 22, 230));
      -webkit-background-clip: text;
      color: transparent;
      font-size: 30px;
    }
    .web-title {
      // font-family: 'hanyitaozaizijian';
      font-family: 'PingFang SC Semibold', 'PingFang SC', sans-serif;
      font-size: 25px;
      font-weight: 600;
      color: rgb(45 106 234);
      @media (max-width: 794px) {
        display: none;
      }
    }
  }
  .header-backBtn {
    margin-right: 20px;
  }
}
.operate-left {
  display: flex;
  align-items: center;
  .color-picker {
    :deep(.ant-btn) {
      display: flex;
      align-items: center;
      padding-left: 0px;
    }
  }
}
:deep(.ant-btn) {
  margin-right: 10px!important;
}

.create-box {
  position: relative;
  height: 40px;
  @apply mb-4;
  .resume-total {
    font-weight: bold;
    @apply pl-2;
    font-size: 14px;
    color: #999;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .create-btn {
    font-size: 15px;
    color: #666;
    cursor: pointer;
    border: 1px solid #999;
    border-radius: 4px;
    @apply p-2 py-1;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    &:hover {
      color: #1890ff;
      border-color: #1890ff;
    }
  }
}

.userNameSpan {
  max-width: 120px;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-item {
  font-size: 18px;
  position: relative;
  top: 2px;
}

.mune-item {
  font-weight: 600;
  &:hover {
    color: #1890ff;
  }
}

.backbtn-box {
  @apply relative;
}

.my-resume-list {
  @apply ml-4 cursor-pointer;
}

.CountdownCls {
  @apply pl-6;
}

.mune-item-back {
  color: #999;
  &:hover {
    color: #1890ff;
  }
}

.mune-item-btn-active {
  color: #1890ff;
  @apply relative;
  background: transparent !important;
  &::after {
    content: '';
    @apply absolute bottom-0 left-1/2;
    transform: translateX(-50%);
    height: 3px;
    background: #1890ff;
    width: 80%;
  }
}

.more-tools {
  display: contents;
}

.loginUser {
  display: flex;
  // align-items: center;
}

.PDFBth {
  @media (max-width: 794px) {
      display: none;
    }
}

.downloadCount {
  height: 32px;
  line-height: 32px;
  @apply mr-8;
  font-size: 13px;
  color: #8d8d8d;
  cursor: not-allowed;
  span {
    color: #f24672;
  }
}

.vipSvgIcon {
  @apply inline-block ml-2;
  width: 22px;
  height: 22px;
}

.myResumeListBox {
  width: 100%;
  height: 400px;
  overflow-y: scroll;
}

.wap-munue-box {
  width: 40px;
  position: relative;
  .more-icon {
    width: 30px;
    height: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    display: flex;
    align-items: center;
  }
  .wap-munue-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9;
    .wap-munue-mask-close {
      position: absolute;
      display: block;
      top: 5px;
      right: 10px;
      width: 30px;
      height: 30px;
      color: #f0f0f0;
      font-size: 24px;
    }
    .wap-munue-body {
      width: 240px;
      height: 100%;
      background: #fff;
      .wap-munue-item {
        border-bottom: 1px solid #f0f0f0;
        @apply px-3 relative flex;
        align-items: center;
        span {
          @apply absolute top-1/2 right-6;
          transform: translateY(-50%);
          font-size: 24px;
          font-weight: 400;
        }
        &:hover {
          background: #018ae0;
          color: #f0f0f0;
        }
      }
    }
  }
}
</style>